import type { AnyAction } from 'redux';
import * as Navigation from 'constants/navigation';

export interface NavigationState {
  leftDrawerOpen: boolean;
  activeTab: string | null;
}

const initialState: NavigationState = {
  leftDrawerOpen: false,
  activeTab: null,
};

export default function navigation(
  state: NavigationState = initialState,
  action: AnyAction,
): NavigationState {
  switch (action.type) {
    case Navigation.OPEN_LEFT_DRAWER:
      return { ...state, leftDrawerOpen: true };
    case Navigation.CLOSE_LEFT_DRAWER:
      return { ...state, leftDrawerOpen: false, activeTab: null };
    case Navigation.OPEN_LEFT_DRAWER_WITH_TAB:
      return {
        ...state,
        leftDrawerOpen: true,
        activeTab: action.payload.tabId,
      };
    default:
      return state;
  }
}
